import { process } from "am-tax-fe-core";

import { components } from "../generated/generated-api";
import { client } from "../entities/entityApi";

//#region Dto definition
export type ReportEntity = components["schemas"]["ReportEntityDto"];
export type CreateReportEntity = components["schemas"]["CreateOrUpdateReportEntityDto"];
export type UpdateReportEntity = components["schemas"]["CreateOrUpdateReportEntityDto"];

export const getReportEntityAsync = async (args: { reportId: string; leadEntityId: string }): Promise<ReportEntity> =>
    process(
        client().GET("/api/reportentities/{reportId}/{leadEntityId}", {
            params: {
                path: {
                    reportId: args.reportId,
                    leadEntityId: args.leadEntityId,
                },
            },
        }),
    );

export const getAllReportEntitiesAsync = async (): Promise<ReportEntity[]> => process(client().GET("/api/reportentities"));

export const createReportEntityAsync = async (args: CreateReportEntity): Promise<ReportEntity> => process(client().POST("/api/reportentities", { body: args }));

export const updateReportEntityAsync = async (args: UpdateReportEntity): Promise<ReportEntity> =>
    process(
        client().PUT("/api/reportentities/{reportId}/{leadEntityId}", {
            params: {
                path: {
                    reportId: args.reportId,
                    leadEntityId: args.leadEntityId,
                },
            },
            body: args,
        }),
    );

export const deleteReportEntityAsync = async (args: { reportId: string; leadEntityId: string }): Promise<ReportEntity> =>
    process(
        client().DELETE("/api/reportentities/{reportId}/{leadEntityId}", {
            params: {
                path: {
                    reportId: args.reportId,
                    leadEntityId: args.leadEntityId,
                },
            },
        }),
    );
